import lodash, { isEmpty } from 'lodash'
import React, { useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'
import styled from 'styled-components'

import Alert from '../../../../../1stlog-ui/src/components/Alert'
import Checkbox from '../../../../../1stlog-ui/src/components/Checkbox'
import Icon from '../../../../../1stlog-ui/src/components/Icon'
import Tooltip from '../../../../../1stlog-ui/src/components/Tooltip'
import Truncate from '../../../../../1stlog-ui/src/components/Truncate'
import { colors, getTasks, getTerms, incoSplit, TIncoTerm } from './data'

const Wrapper = styled.div``

const Party = styled.div`
  font-size: 1.2em;
  font-weight: bold;
  color: ${({ color }) => color};
`

export type TProps = {
  isReadonly?: boolean
  value: string
  onChange: (v: string) => void
  exporter?: string
  importer?: string
}

const IncoTerms2020 = (props: TProps): React.ReactElement => {
  const {
    isReadonly,
    value,
    onChange,
    exporter = i18n.t('exporter', 'Exporteur'),
    importer = i18n.t('importer', 'Importeur'),
  } = props

  const terms = getTerms()
  const tasks = getTasks()

  const getSelectedIndex = (value: string): number => {
    return lodash.findIndex(terms, ({ name }) => lodash.isEqual(name, value))
  }

  const getSelectedTerm = (value: string): TIncoTerm | undefined => {
    return lodash.find(terms, ({ name }) => lodash.isEqual(name, value))
  }

  const selectedIndex = getSelectedIndex(value)
  const selectedTerm = getSelectedTerm(value)

  const [isCustomsTermsMarineEnabled, setIsCustomsTermsMarineEnabled] =
    useState(false)

  const isMarineRequired = lodash.get(selectedTerm, 'marineOnly')

  useEffect(() => {
    if (!isCustomsTermsMarineEnabled && isMarineRequired) {
      setIsCustomsTermsMarineEnabled(true)
    }
  }, [value, isCustomsTermsMarineEnabled])

  return (
    <Wrapper>
      {isEmpty(value) && (
        <Alert info>
          {i18n.t(
            'incoterms_2020_select_hint',
            'Bitte klicken Sie auf eine Spalte, um eine Option auszuwählen',
          )}
          .
        </Alert>
      )}
      <Table striped>
        <thead>
          {isCustomsTermsMarineEnabled && (
            <tr>
              <th></th>
              <th colSpan={2}></th>
              <th
                colSpan={4}
                className="text-center"
                style={{
                  borderRight: '3px solid #dee2e6',
                  borderLeft: '3px solid #dee2e6',
                }}
              >
                {i18n.t(
                  'sea_freight_&_inland_shipping_only',
                  'Nur Seefracht & Binnenschifffahrt',
                )}
              </th>
              <th colSpan={5}></th>
            </tr>
          )}
          <tr>
            <th>
              <Party color={lodash.get(colors, 1)}>
                {i18n.t('exporter', 'Exporteur')}
              </Party>
            </th>
            {lodash.map(
              terms,
              ({ name, description, marineOnly, borderLeft, borderRight }) => {
                if (marineOnly && !isCustomsTermsMarineEnabled) {
                  return null
                }
                const style = {
                  borderLeft: '1px solid #dee2e6',
                  borderRight: '0px solid lime',
                }
                if (borderLeft) {
                  style.borderLeft = '3px solid #dee2e6'
                }
                if (borderRight) {
                  style.borderRight = '3px solid #dee2e6'
                }
                const isSelected = lodash.isEqual(name, value)
                return (
                  <Tooltip tooltip={description} key={name}>
                    <th
                      className="text-center"
                      style={{
                        ...style,
                        backgroundColor: isSelected
                          ? '#eaecf0'
                          : // : marineOnly
                            // ? "#eaecf0"
                            'white',
                        cursor: isReadonly ? '' : 'pointer',
                        whiteSpace: 'nowrap',
                      }}
                      onClick={isReadonly ? undefined : () => onChange(name)}
                    >
                      {lodash.toUpper(name)}{' '}
                      <span className="text-muted">
                        <Icon size={0.7} icon="fas fa-question-circle" />
                        {/* {marineOnly && (
                        <Icon
                          size={0.7}
                          icon="fas fa-anchor"
                          className="pl-1"
                        />
                      )} */}
                      </span>
                    </th>
                  </Tooltip>
                )
              },
            )}
          </tr>
        </thead>
        <tbody>
          {lodash.map(tasks, (task, x) => (
            <tr>
              <td>{task.description}</td>
              {lodash.map(
                terms,
                ({ marineOnly, name, borderLeft, borderRight }, y) => {
                  if (marineOnly && !isCustomsTermsMarineEnabled) {
                    return null
                  }
                  const data = incoSplit[x][y]

                  const isSelected = selectedIndex === y
                  const style = {
                    borderLeft: '1px solid #aaa',
                    borderRight: '0px solid lime',
                  }
                  if (borderLeft) {
                    style.borderLeft = '3px solid #ccc'
                  }
                  if (borderRight) {
                    style.borderRight = '3px solid #ccc'
                  }
                  return (
                    <td
                      style={{
                        ...style,
                        backgroundColor: lodash.get(colors, data),
                        color: '#fff',
                        opacity: isSelected ? '1' : '0.6',
                        cursor: isReadonly ? '' : 'pointer',
                      }}
                      className="text-center"
                      onClick={isReadonly ? undefined : () => onChange(name)}
                      key={name}
                    >
                      {data === 1 && isSelected && (
                        <Truncate
                          maxLength={isCustomsTermsMarineEnabled ? 10 : 30}
                        >
                          {exporter}
                        </Truncate>
                      )}
                      {data === 2 && isSelected && (
                        <Truncate
                          maxLength={isCustomsTermsMarineEnabled ? 10 : 30}
                        >
                          {importer}
                        </Truncate>
                      )}
                      {/* {data > 0 && <Icon icon="fal fa-check" />} */}
                      {/* {data} */}
                      {/* {x},{y} */}
                    </td>
                  )
                },
              )}
            </tr>
          ))}
          <tr>
            <td>
              <Party color={lodash.get(colors, 2)}>
                {i18n.t('importer', 'Importeur')}
              </Party>
            </td>
            {!isReadonly && (
              <td colSpan={11}>
                <div className="d-flex justify-content-end mr-n2">
                  <Checkbox
                    value={isCustomsTermsMarineEnabled}
                    onChange={(value) =>
                      setIsCustomsTermsMarineEnabled(value as boolean)
                    }
                    disabled={isMarineRequired}
                  >
                    {i18n.t(
                      'customs_terms_enable_marine',
                      'Verzollung für Seefracht & Binnenschifffahrt anzeigen',
                    )}
                  </Checkbox>
                </div>
              </td>
            )}
          </tr>
        </tbody>
      </Table>
    </Wrapper>
  )
}

export default IncoTerms2020
